<template>
  <div class="menu-v2-container">
    <div v-for="menu in menus" :key="menu.info.key">
      <div class="menu-v2-level1-wrapper">
        <a-popover overlayClassName='left-menu-v2-popover' trigger='hover' placement="rightTop" :autoAdjustOverflow="true">
          <template slot="content">
            <div class="menu-v2-level2-3" v-for="level2menu in menu.children" :key="level2menu.info.key">
              <header>
                <h3>{{level2menu.info.title}}</h3>
                <!-- <a-icon type="down" style="color: #999999;" /> -->
              </header>
              <div class="menu-v2-level3-wrapper">
                <div class="menu-v2-level3-item" v-for="level3menu in level2menu.children" :key="level3menu.info.key">
                  <a class="menu-v2-link" :class="{'active': level3menu.info.key === activeKey}" :href="level3menu.info.link" @click="menuSelectHandler(level3menu, level3menu.info.key, $event, [menu.info.title, level2menu.info.title, level3menu.info.title])" target='iframe-page'>{{level3menu.info.title}}</a>
                  <img v-if="level3menu.info.pined" src="@assets/images/pined.png" @click="handlePin(menu.info.id, level3menu.info.id, false)" />
                  <img v-else src="@assets/images/unpin.png" @click="handlePin(menu.info.id, level3menu.info.id, true)" />
                </div>
              </div>
            </div>
          </template>
          <div class="menu-v2-level1">
            <div class="content">
              <img :src="$viewImage(menu.info && menu.info.icon)" width="16" height="16" />
              <h3>{{menu.info.title}}</h3>
            </div>
            <a-icon type="right" style="color: #999999;" />
          </div>
        </a-popover>
      </div>
      <div class="menu-v2-pined-wrapper">
        <template v-for="submenu in menu.children">
          <template v-for="item in submenu.children">
            <div :key="item.id" class="pined-menu-item" v-if="item.info.pined" :title="item.info.title">
              <a class="menu-v2-link" :class="{'active': item.info.key === activeKey}" :href="item.info.link" @click="menuSelectHandler(item, item.info.key, $event, [menu.info.title, submenu.info.title, item.info.title])" target='iframe-page'>{{item.info.title}}</a>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import CommonMixin from '@/mixins/global'
  import { tracker } from '@/utils/utils'
  import { Popover, Icon } from 'ant-design-vue'
  export default {
    name: 'left-menu-v2',
    components: {
      [Popover.name]: Popover,
      [Icon.name]: Icon
    },
    data() {
      return {
        activeKey: ''
      }
    },
    mixins: [ CommonMixin ],
    methods: {
      menuSelectHandler (item, key, e, menuPath) {
        this.setCurrentMenuPath(menuPath)
        this.activeKey = key
        const { buzzType } = this.userInfo
      
        // 热力图统计埋点数据上报
        if (buzzType === 1 || buzzType === 2) {
          // pop
          tracker(116, 121013119, 20000, 200001, {path: key})
        } else if (buzzType === 3) {
          // 品牌商
          tracker(116, 121013121, 20000, 200001, {path: key})
        } else if (buzzType === 4) {
          // 供应商
          tracker(116, 121013122, 20000, 200001, {path: key})
        }
        const openKeys = []
        this.$emit('change', {...item, openKeys, selectedKeys: [key]})
        e.preventDefault()
        return false
      },
      handlePin (level1Id, level3Id, pin) {
        this.$store.dispatch('updatePinedMenus', {level1Id, level3Id, pin})
      },
    }
  }
</script>
<style scoped lang="scss">
  .menu-v2-container {
    padding: 12px 0;
    .menu-v2-level1-wrapper {
      display: flex;
      cursor: pointer;
      &:hover {
        background: #F8FAFC;
      }
      &::after {
        display: block;
        content: '';
        width: 4px;
        height: 40px;
      }
      .menu-v2-level1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        width: 196px;
        padding: 0 16px;
        .content {
          display: flex;
          align-items: center;
          &>img {
            margin-right: 6px;
          }
          &>h3 {
            font-size: 14px;
            font-weight: 600;
            color: #333333;
            line-height: 20px;
            cursor: pointer;
          }
        }
      }
    }
    .menu-v2-pined-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 200px;
      padding-right: 20px;
      .pined-menu-item {
        padding-left: 16px;
        width: 90px;
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    
  }
</style>
<style lang="scss">
  .left-menu-v2-popover {
    padding-left: 0;
    .ant-popover-arrow {
      display: none !important;
    }
    .ant-popover-inner {
      border-radius: 0;
      box-shadow: 9px 0px 12px 0px rgba(0, 0, 0, 0.08);
    }
    .ant-popover-inner-content {
      padding: 0;
    }
    .menu-v2-level2-3 {
      padding-bottom: 8px;
      header {
        display: flex;
        align-items: center;
        padding: 10px 20px;
      }
      h3 {
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        line-height: 20px;
        margin-right: 10px;
      }
    }
    .menu-v2-level3-wrapper {
      display: flex;
      flex-wrap: wrap;
      max-width: 360px;
      .menu-v2-level3-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 8px 0 20px;
        width: 180px;
        height: 32px;
        img {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }
      }
    }
  }
  a.menu-v2-link {
    flex: 1;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    &.active, &:hover{
      color: #1066CC;
    }
    text-decoration: none;
  }
</style>
